import { useState } from 'react';
import { Grid } from '@material-ui/core';
import { useDefaultCadastroStyles } from '../cadastros/components/default-cadastro-styles';
import { PropagandaListSearchProps } from './components/propaganda-list/propaganda-list-search-props';
import { PropagandaList } from './components/propaganda-list/propaganda-list';
import { PropagandaHeader } from './components/propaganda-header/propaganda-header';
import { ButtonFab } from 'views/components/controles';
import { NovoIcon } from 'views/components/icons';
import { useHistory } from 'react-router-dom';

export const PropagandaPage = () => {
    const classes = useDefaultCadastroStyles();
    const { push } = useHistory();
    const [selectedList, setSelectedList] = useState<Array<string>>([]);
    const [openPesquisa, setOpenPesquisa] = useState(false);
    const [searchProps, setSearchProps] = useState<PropagandaListSearchProps>({
        Descricao: '',
        DtInicial: '',
        DtFinal: '',
        Ativo: true,
        Local: -1,
    });

    const onCardChecked = (id: string) => {
        const aux = [...selectedList];
        aux.push(id);
        setSelectedList(aux);
    };

    return (
        <Grid className={classes.root}>
            <Grid className={classes.header}>
                <PropagandaHeader
                    openPesquisa={openPesquisa}
                    setOpenPesquisa={setOpenPesquisa}
                    setSearchProps={setSearchProps}
                />
            </Grid>
            <PropagandaList onCardChecked={onCardChecked} searchProps={searchProps}></PropagandaList>
            <ButtonFab
                tooltip="Nova Propaganda"
                icon={<NovoIcon tipo="BUTTON_FAB" />}
                onClick={() => push('/propaganda/adicionar')}
            />
        </Grid>
    );
};

export default PropagandaPage;